// src/utils/notificationSound.js

let audioContext = null;

export const playNotificationSound = () => {
    try {
        // Создаём контекст, если его ещё нет
        if (!audioContext) {
            audioContext = new (window.AudioContext || window.webkitAudioContext)();
        }

        // Если контекст "спит" (после сворачивания вкладки) — пробуждаем
        if (audioContext.state === 'suspended') {
            audioContext.resume();
        }

        const now = audioContext.currentTime;

        // Создаём осциллятор (генератор звука)
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        // Настраиваем звук: две короткие ноты
        oscillator.type = 'sine';
        oscillator.frequency.setValueAtTime(880, now);        // Первая нота (A5)
        oscillator.frequency.setValueAtTime(1174.66, now + 0.1); // Вторая нота (D6)

        // Плавное затухание
        gainNode.gain.setValueAtTime(0.3, now);
        gainNode.gain.exponentialRampToValueAtTime(0.01, now + 0.25);

        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);

        oscillator.start(now);
        oscillator.stop(now + 0.25);
    } catch (error) {
        console.warn('Не удалось воспроизвести звук:', error);
    }
};